import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatMoney } from '../utils'

export const mwmCostPerUserDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'costPerFreeTrialD0Avg',
      field: 'mwm_cost_per_free_trial_d0',
      headerName: 'Cost per FreeTrial D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'costPerFreeTrialD10Avg',
      field: 'mwm_cost_per_free_trial_d10',
      headerName: 'Cost per FreeTrial D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'costPerFreeTrialLifetimeAvg',
      field: 'mwm_cost_per_free_trial_lifetime',
      headerName: 'Cost per FreeTrial Lifetime',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'costPerSubscriberD0Avg',
      field: 'mwm_cost_per_subscriber_d0',
      headerName: 'Cost per Subscriber D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'costPerSubscriberD10Avg',
      field: 'mwm_cost_per_subscriber_d10',
      headerName: 'Cost per Subscriber D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'costPerSubscriberLifetimeAvg',
      field: 'mwm_cost_per_subscriber_lifetime',
      headerName: 'Cost per Subscriber Lifetime',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'costPerPayingUserD0Avg',
      field: 'mwm_cost_per_paying_user_d0',
      headerName: 'Cost per Paying D0',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'costPerPayingUserD10Avg',
      field: 'mwm_cost_per_paying_user_d10',
      headerName: 'Cost per Paying D10',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'costPerPayingUserLifetimeAvg',
      field: 'mwm_cost_per_paying_user_lifetime',
      headerName: 'Cost per Paying Lifetime',
      type: 'numericColumn',
      valueFormatter: formatMoney,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'MWM Cost per User',
}
